import React from "react";
import SocialLogin from "react-social-login";
import { Button } from "@mui/material";
class SocialButton extends React.Component {
  render() {
    const { children, triggerLogin, ...props } = this.props;
    return (
      <Button
        variant="outlined"
        style={{
          color: "#152A74",
          border: "2px solid #152A74",
          display: "flex",
          alignItems: "center",
          borderRadius: "5px",
        }}
        onClick={triggerLogin}
        {...props}
      >
        {children}
      </Button>
    );
  }
}

export default SocialLogin(SocialButton);
